import { useHistory } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { Button, Form, Modal, Spinner } from "react-bootstrap-v5";
import Select from 'react-select';
// import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import AutoCompleteProduct from "react-autocomplete"
import { productServices } from '../../../Services/index';
import AutoComplete from '../../AutoComplete';
import SimpleReactValidator from 'simple-react-validator';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import EnquiryService from '../../../Services/EnquiryService';
import { retailerService } from '../../../Services';
import { toast } from 'react-toastify';
import getRandomkeys from '../../../Components/StringGenerator';
import Loader from '../../../Components/Loader';
import EnquiryHelper from './EnquiryHelper';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { customerServiceService } from '../../../Services/index';

const customer_Type = [
  { value: 'TOURIST', label: 'Tourist' },
  { value: 'RESIDENT', label: 'Resident' },
  { value: 'OVERSEASCUSTOMER', label: 'Overseas shoppers' },
];

export const AddEnquiry = () => {
  const history = useHistory();

  const [, setForceUpdate] = useState('');
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );
    const [productModal,setProductModal] = useState({open:false,data:null,index : 0})
  const [loader, setLoader] = useState({
    air_loader: false,
    sea_loader: false,
    courier_loader: false,
    land_loader: false,
  });

  // state for redirection
  const [airredirect, setAirRedirect] = useState(false);
  const [seaRedirect, setSeaRedirect] = useState(false);
  const [courierRedirect, setCourierRedirect] = useState(false);
  const [landRedirect, setLandRedirect] = useState(false);
  const [deliverer, setDeliverer] = useState("RETAILER");

  const initial1 =  {item_id: '',type:"enter",
        item_description: "",
        no_of_pkgs: "",
        dimension: {
          kilogram: "",
          length: "",
          width: "",
          height: "",
        },
        total_volume_CBM: "",
        total_weight_KG: "",
        item_token: EnquiryHelper.stringGenerator(24),};
  const [OrginValue, setOrginValue] = useState('');
  const [DestinationValue, setDestinationValue] = useState('');
  const [Keyword, setKeyword] = useState(null);

  // const [productList, setProductList] = useState([initial]);
  const [productItemForArray, setProductItemForArray] = useState([initial1]);
  const [productItem, setProductItem] = useState([]);
  // const [selectProductList, setSelectProductList] = useState([]);

  const [goodValue, setGoodValue] = useState('');
  const [itemValue, setItemValue] = useState([]);
  const [customerServiceList, setCustomerServiceList] = useState([]);

  const [Phonenumber, setPhonenumber] = useState('');
  const [Codenumber, setCodenumber] = useState('');
  const [usertype, setUsertype] = useState('');
  const [email, setEmail] = useState('');
  const [customerName, setCustomerName] = useState();
  // const [tabhandler, setTabhandler] = useState('Table');
  const [quoteToken, setQuoteToken] = useState('');
  const [retailerListData, setRetailerListData] = useState([]);
  const [salesperson, setSalesperson] = useState();
  const [generalDetailsObj, setGeneralDetailsObj] = useState({
    retailer_id: '',
    retailer_name: '',
    referral_code: '',
    sales_person: '',
    promo_code: '',
    customer_service: '',
  });

  const [isLoading, setLoading] = useState(false)
  const [custmorOptions, setCustmorOptions] = useState([])


  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, []);


  const getItemList = () => {
    let param = {role : "customer_service"} 
    customerServiceService.getCustomerService(param).then((res) => {
      if (res.status) {
        let arr = []
        // for(let i =0;i<res.data.length;i++){
        //   if(res.data[i].department === 'CUSTOMERSERVICE'){
        //     arr.push({...res.data[i],value:res.data[i].employee_name,label:res.data[i].employee_name})
        //   }
        // }
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].employee_name){
            arr.push({
              ...res.data[i],
              value: res.data[i]?.employee_name,
              label: res.data[i]?.employee_name,
            });
          }
        }
        setCustomerServiceList(arr);
      }
    });
  };

  const getGrandTotal = () => {
    let arry = [...productItemForArray]
    let gTotal = {
      number_of_packages : 0,
      volume : 0,
      weight : 0,
    }
    for (let i = 0; i < arry.length; i++) {
      if(i>0 && arry[i-1].item_description===arry[i].item_description){
        }else{
          gTotal.number_of_packages +=(arry[i]?.no_of_pkgs ? Number(arry[i].no_of_pkgs) : 0)
          gTotal.volume +=(arry[i]?.total_volume_CBM ? Number(arry[i].total_volume_CBM) : 0)
          gTotal.weight +=(arry[i]?.total_weight_KG ? Number(arry[i].total_weight_KG) : 0)
        }
      }
    return {...gTotal,volume:gTotal.volume.toFixed(3)}
  }


  
  const onChangeEvent = (key, event,subkey) => {
    let { name, value } = event.target;
    let arry = [...productItemForArray];
    let obj = arry[key];
    
    if (name != 'kilogram' && name != 'item_description') {
      obj['total_volume_CBM'] = getCBM(obj, name, value);
    }
    
    if (name === 'kilogram' || name === 'no_of_pkgs') {
      obj['total_weight_KG'] = getTKg(obj, name, value);
    }
    
    if(subkey){
      obj[subkey][name] = value;
    }else{
      obj[name] = value;
    }
    arry.splice(key, 1, obj);
    setProductItemForArray(arry)
  };

  const getTKg = (obj, act, count) => {
    switch (act) {
      case 'kilogram':
        return obj.no_of_pkgs * count;
      case 'no_of_pkgs':
        return count * obj.dimension.kilogram;
    }
  };

  const getCBM = (obj, act, count) => {
    switch (act) {
      case 'no_of_pkgs':
        return (
          Number(count) *
          ((Number(obj.dimension.length) * Number(obj.dimension.width) * Number(obj.dimension.height)) / 1000000)
        ).toFixed(3);
      case 'length':
        return (
          Number(obj.no_of_pkgs) *
          ((Number(count) * Number(obj.dimension.width) * Number(obj.dimension.height)) / 1000000)
        ).toFixed(3);
      case 'width':
        return (
          Number(obj.no_of_pkgs) *
          ((Number(obj.dimension.length) * Number(count) * Number(obj.dimension.height)) / 1000000)
        ).toFixed(3);
      case 'height':
        return (
          Number(obj.no_of_pkgs) *
          ((Number(obj.dimension.length) * Number(obj.dimension.width) * Number(count)) / 1000000)
        ).toFixed(3);
    }
  };

  const addProductHandler = () => {
    let addArray = [...productItemForArray];
    addArray.push(initial1);
    setProductItemForArray(addArray);
    // let addArray = [...productList];
    // addArray.push(initial);
    // setProductList(addArray);
  };

  const deleteProductHandler = (key,item) => {
    // let deleteArray = [...productList];
    // deleteArray.splice(key, 1);
    // setProductList(deleteArray);
    let arr = [...productItemForArray]
    if(item.type==="select"){
      let filteredArr = arr.filter((itm)=> itm.item_description!==item.item_description)
      setProductItemForArray(filteredArr)
    }else{
      arr.splice(key,1)
      setProductItemForArray(arr)
    }

  };

  //// handlers for Google Map autoComplete
  const getOriginData = (e) => {
    if (e === '') {
      setOrginValue('');
    } else {
      let originData = {
        origin_country: e.country,
        origin_country_short_name: e.country_short_name,
        origin_city: e.city,
        origin_latitude: e.latitude,
        origin_longitude: e.longitude,
      };
      setOrginValue(originData);
    }
  };

  const getDestinationData = (e) => {
    if (e === '') {
      setDestinationValue('');
    } else {
      let destinationData = {
        destination_country: e.country,
        destination_country_short_name: e.country_short_name,
        destination_city: e.city,
        destination_latitude: e.latitude,
        destination_longitude: e.longitude,
      };
      setDestinationValue(destinationData);
    }
  };
  ///

  useEffect(() => {
    // const timeOut = setTimeout(() => {
      if(Keyword){
        getProductlist();
      }
    // }, 1000);
    // return () => {
    //   clearTimeout(timeOut);
    // };
  }, [Keyword]);

  //// function for ProductListapi calling

  const getProductlist = () => {
    let searchData = {
      search: Keyword,
    };
    productServices.getProduct(searchData).then((result) => {
      if (result.status === true) {
        let Productarray = result.data.map((item) => ({
          value: item._id,
          label: item.product_name,
          data: item,
        }));
        setProductItem(Productarray);
      }
    });
  };

  const searchHandler = (event) => {
    setItemValue(event.target.value);
    if (event.target.value.length >= 2) {
      setKeyword(event.target.value);
    }else{
      setKeyword("");
    }
  };

  /// for product search

  const handleChange = (getvalue) => {
    setItemValue(getvalue);
    new_conditionFun(getvalue);
  };

  const addSelectedProduct = () => {
    // console.log(productModal.data,'productModal.data')
    let item = []
      let itemObj = productItem.find((item)=> item.label===productModal.data)
      let findItemObj = productItemForArray.find((item)=> item.item_description===productModal.data)
        if(findItemObj){
        }else{
          for (let i = 0; i < itemObj.data.product_dimentions.length; i++) {
            item.push({
              type : "select",
                item_id: itemObj.data._id,
                item_description: itemObj.data.product_name,
                no_of_pkgs: "1",
                dimension: {
                  kilogram: itemObj.data.product_dimentions[i].weight,
                  length:itemObj.data.product_dimentions[i].length,
                  width: itemObj.data.product_dimentions[i].width,
                  height: itemObj.data.product_dimentions[i].height,
                },
                total_volume_CBM: itemObj.data.product_gross_volume,
                total_weight_KG: itemObj.data.product_gross_weight,
            })
          }
        }
        let tempItem = productItemForArray
        tempItem.splice(productModal.index,1,...item)
        setProductItemForArray(tempItem)
    setProductModal({open:false,data:null,index:0})
    setProductItem([])
    setItemValue("")
    setKeyword("")
  }

  const new_conditionFun = (val) => {
    setProductModal({...productModal,data:val})
  };
  /// function for Retailer api

  useEffect(() => {
    getRetalerItemList();
  }, []);

  const getRetalerItemList = () => {
    retailerService.getRetailer().then((res) => {
      if (res.status) {
        let listArry = [{ value: 'none', label: 'None' }];
        res.data.map((val) => {
          listArry.push({
            value: val,
            label: val.retailer_name,
            contact_name: val.contact_name,
          });
        });
        setRetailerListData(listArry);
      }
    });
  };

  // get data by referral_code 
  const handleRefferalChange = (e) => {
    setGeneralDetailsObj({
      ...generalDetailsObj,
      referral_code: e.target.value,
    })
    let param = {referral_token: e.target.value}
    retailerService.getRefferelRetailerData(param).then((res) => {
      if(res.status){
        retailerListData.map((item) => {
          if(item.label === res.data.retailer_name){
            if(res.data.isreftoken === 1){
              setGeneralDetailsObj({
                ...generalDetailsObj,
                retailer_id: item.value._id,
                retailer_name:item.label,
                sales_person:item.contact_name,
                referral_code: e.target.value,
                promo_code: '',
                referral_id: item.value._id,
              })
            }else{
              setGeneralDetailsObj({
                ...generalDetailsObj,
                retailer_id: item.value._id,
                retailer_name:item.label,
                sales_person:item.contact_name,
                promo_code: e.target.value,
                referral_code: e.target.value,
                referral_id: item.value._id,
              })
            }
          }
        })
      }
    })
  }
  // get data by referral_code 


  const retailerHandler = (event) => {
    let salesObj = {};
    if (event.value === 'none') {
      setSalesperson('');
      setGeneralDetailsObj({
        ...generalDetailsObj,
        sales_person: '',
        retailer_name: event.label,
        referral_code: '',
        retailer_id: '',
      });
    } else {
      retailerListData &&
        retailerListData.find((val) => {
          if (event.label === val.label) {
            salesObj = val.contact_name;
          }
        });

      setGeneralDetailsObj({
        ...generalDetailsObj,
        retailer_id: event.value._id,
        sales_person: salesObj,
        retailer_name: event.label,
        referral_code: event.value.referral_token,
        referral_id: event.value._id,
      });
    }
  };
  //// function for Quote api calling

  const submitQuoteHandler = (e) => {
    e.preventDefault();

    let postData = null;
    let random_key = getRandomkeys();
    let validate = 0;
      if (productItemForArray.length > 0) {
        let grandWeight = 0;
        let grandVolume = 0;
        let array = [];
        productItemForArray &&
          productItemForArray.map((ele) => {
            array.push({
              ...ele,
              total_weight_KG: Number(ele.no_of_pkgs * ele.dimension.kilogram),
              total_volume_CBM: Number(ele.no_of_pkgs * ele.total_volume_CBM),
              item_token: EnquiryHelper.stringGenerator(24),
            });
            grandWeight += Number(ele.no_of_pkgs * ele.dimension.kilogram);
            grandVolume += Number(ele.no_of_pkgs * ele.total_volume_CBM);
          });

        postData = {
          ...OrginValue,
          ...DestinationValue,
          deliverer:deliverer,
          number_of_packages: getGrandTotal()?.number_of_packages,
          volume: parseFloat(grandVolume),
          weight: grandWeight,
          items_goods: Number(goodValue),
          items: array,
          quote_token: random_key,
          general_details: generalDetailsObj,
        };
      }
      validate = EnquiryHelper.validationEnquiryAddedFilter(validator, generalDetailsObj)
    // }

    if (validate) {
      setLoader({
        air_loader: true,
        sea_loader: true,
        courier_loader: true,
        land_loader: true,
      });
      signupQuotesSubmit(postData);
      // apiCallFunc(postData);
    } else {
      validator.current.showMessages();
    }
  };

  //////

  const setQuotesPhone = (event, g) => {
    // setPhonenumber(event);
    if (g.target.value) {
      let num = g.target.value
        .split(' ')
        .slice(1)
        .join('')
        .replace(/[^a-zA-Z0-9]/g, '');
      let code = g.target.value.split(' ')[0];
      // matchNumber(Phonenumber);

      setPhonenumber(num);
      setCodenumber(code);
    }
  };

  const signupQuotesSubmit = (data) => {
    let Quotesdata = {
      user_full_name: customerName,
      user_email: email.toLowerCase(),
      user_name: email,
      user_phone_number: Phonenumber,
      user_dial_code: Codenumber,
      user_type: usertype.value,
    };
    // apiCallFunc(data);
    EnquiryService.Quotesignup(Quotesdata)
      .then((result) => {
        if (result.status === true) {
          apiCallFunc(data, result.data._id);
          // setLoader({
          //   air_loader: true,
          //   sea_loader: true,
          //   courier_loader: true,
          //   land_loader: true,
          // });
        } else {
          toast.error(result.message);
          setLoader({
            air_loader: false,
            sea_loader: false,
            courier_loader: false,
            land_loader: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const findCustomer = (email) => {
    setEmail(email)
    setLoading(true)
    let postdata = {
      user_email: email
    }
    EnquiryService.findCustomerApi(postdata)
      .then((result) => {
        if (result.status === true) {

          setCustmorOptions(result.data)
        } else {
          setPhonenumber('');
          setCodenumber('');
          setCustomerName('');
          setUsertype('');
        }
      })
    setLoading(false)
  }

  const apiCallFunc = (collection, userid) => {
    if (userid) {
      collection['user_id'] = userid;
    }

    // for courier
    EnquiryService.getQuoteToken().then((token) => {
      collection.quote_token = token.data;

      EnquiryService.postCourierQuote(collection)
        .then((result) => {
          if (result.status === true) {
            if(result?.data?.quote_token) setQuoteToken(result.data.quote_token || '');
            setCourierRedirect(true);
          } else {
            setLoader({
              courier_loader: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // for air

      EnquiryService.postAirQuote(collection)
        .then((result) => {
          if (result.status === true) {
            setAirRedirect(true);
            if(result?.data?.quote_token) setQuoteToken(result.data.quote_token || '');
          } else {
            setLoader({
              air_loader: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // for sea

      EnquiryService.postSeaQuote(collection)
        .then((result) => {
          if (result.status === true) {
            setSeaRedirect(true);
            if(result?.data?.quote_token) setQuoteToken(result.data.quote_token || '');
          } else {
            setLoader({
              sea_loader: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // for land

      EnquiryService.postLandQuote(collection)
        .then((result) => {
          if (result.status === true) {
            setLandRedirect(true);
            if(result?.data?.quote_token) setQuoteToken(result.data.quote_token || '');
          } else {
            setLoader({
              land_loader: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    })
  };

  useEffect(() => {
    if (airredirect && seaRedirect && courierRedirect && landRedirect) {
      redirectToquote();
      setLoader({
        air_loader: false,
        sea_loader: false,
        courier_loader: false,
        land_loader: false,
      });
    }
  }, [airredirect, seaRedirect, courierRedirect, landRedirect]);

  const redirectToquote = () => {
    history.push('/edit-enquiry?id=' + quoteToken, {quote_token: quoteToken, quote_status:"INQUIRY"} );
  };

  const filterBy = () => true;

  const handleCustomerChange = (obj = []) => {
    if (obj.length > 0) {
      setEmail(obj[0].user_email)
      setPhonenumber(obj[0].user_phone_number);
      setCodenumber(obj[0].user_dial_code);
      setCustomerName(obj[0].user_full_name);
      customer_Type.filter((item => {
        if (item.value === obj[0].user_type) {
          setUsertype({ value: item.value, label: item.label });
        }
      }))
    } else {
      setPhonenumber('');
      setCodenumber('');
      setCustomerName('');
      setUsertype('');
    }
  }
  const handleCloseModal = () => {
    setItemValue("") 
    setProductItem([])
     setProductModal({open:false,data:null,index:0})
     setKeyword("")
  }

  let productCount = 0
  return (
    <div className='row'>
      <div className='col-lg-12'>
        <div className='card'>
          <form
            className='control-form'
            onSubmit={(e) => submitQuoteHandler(e)}
          >
            <section className='sectionBorder'>
              <div className='card-header custom_header'>
                <h5>Shipment Details</h5>
              </div>
              <div className='card-body'>
                <div className='row'>
                  <div className='mb-3 col-6'>
                    <label className='form-label'>Origin</label>
                    <AutoComplete getData={(e) => getOriginData(e)} />
                    {validator.current.message(
                      'Origin',
                      OrginValue,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>
                  <div className='mb-3 col-6'>
                    <label className='form-label'>Destination</label>
                    <AutoComplete getData={(e) => getDestinationData(e)} />
                    {validator.current.message(
                      'Destination',
                      DestinationValue,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>
                </div>
                <div className="row">
                <div className="position-relative me-2 mt-2">
                                <label className="form-label">Who will pickup</label>
                                <div key={`inline-radio`} className="mb-3">
                                    <Form.Check
                                        inline
                                        label="World2Door"
                                        name="deliverer"
                                        value="WORLD2DOOR"
                                        type="radio"
                                        id={`inline-radio-1`}
                                        checked={deliverer === 'WORLD2DOOR'}
                                        onChange={(e) => setDeliverer('WORLD2DOOR')}
                                    />
                                    <Form.Check
                                        inline
                                        label="Self"
                                        name="deliverer"
                                        value="SELF"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={deliverer === 'SELF'}
                                        onChange={(e) => setDeliverer('SELF')}
                                    />
                                    <Form.Check
                                        inline
                                        label="Retailer"
                                        name="deliverer"
                                        value="RETAILER"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={deliverer === 'RETAILER'}
                                        onChange={(e) => setDeliverer('RETAILER')}
                                    />

                                </div>
                            </div>
                </div>

                <div className='calculation_wrapper row justify-content-center'>

                  <div className='tab-content'>
                    <div
                      className='tab-pane active'
                      id='home'
                      role='tabpanel'
                      aria-labelledby='home-tab'
                    >
                      <div className='border-custom col-12 p-3 w-100'>
                        <div className='row'>
                          <div className='mb-3 col-4'>
                            <div className='row'>
                              <div className='col-1 ps-0'>
                                <label className='form-label'>S.No.</label>
                              </div>
                              <div className='col-5' >
                                <label className='form-label'>Product Detail</label>
                              </div>
                              <div className='col-6'>
                                <label className='form-label'>
                                  Product Description
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className='col-1'>
                            <label className='form-label'>Pkgs (No.)</label>
                          </div>

                          <div className='col-4 text-center'>
                            <label className='form-label'>
                              Weight & Dimension per Package
                            </label>
                          </div>

                          <div className='col-3'>
                            <div className='row'>
                              <div className='col-5'>
                                <label className='form-label'>
                                  Total Volume (CBM)
                                </label>
                              </div>
                              <div className='col-5'>
                                <label className='form-label'>
                                  Total Weight (KG)
                                </label>
                              </div>
                              <div className='col-2'></div>
                            </div>
                          </div>
                        </div>

                        {productItemForArray.map((val, key) => {
                            if(key>0 && val.item_description && (productItemForArray[key-1].item_description===val.item_description)){
                            }else{
                              productCount+= 1
                            }
                          return (
                            <div className='row mt-2'>
                              <div className='mb-3 col-4'>
                                <div className='row'>
                                  <div className='px-1 col-1'>
                                  {key>0 && val.item_description && (productItemForArray[key-1].item_description===val.item_description) ? "" :
                                    <p>{productCount}</p>
                          }
                                  </div>

                            {key>0 && val.type==="select" && (productItemForArray[key-1].item_description===val.item_description) ? "" :
                                  <div className="form-group px-1 col-5">
                                    <select className="form-control "
                                    onChange={(e) => {
                                      // onChangeEvent(key, e);
                                      if(e.target.value==="select"){
                                        setProductModal({open:true,data:null,index:key})
                                      }
                                      }}
                                      name="type"
                                     disabled={val.type==="select"}
                                      value={val.type}>
                                      <option value="enter" >Enter manually</option>
                                      <option value="select" >Select from list</option>
                                    </select>
                                    </div>
                            }
                                {key>0 && val.type==="select" && (productItemForArray[key-1].item_description===val.item_description) ? "" :
                                  <div className='col-6 px-1' >
                                    <input
                                      className='form-control'
                                      placeholder='Product Description'
                                      name='item_description'
                                      disabled={val.type==="select"}
                                      value={val.item_description}
                                      onChange={(e) => onChangeEvent(key, e)}
                                    />
                                    {validator.current.message(
                                      'Description',
                                      val.item_description,
                                      'required',
                                      {
                                        className:
                                          'text-danger text-capitalize',
                                      }
                                    )}
                                  </div>}
                                </div>
                              </div>


                              <div className='col-1 ps-1 pe-1'>
                              {key>0 && val.type==="select" && (productItemForArray[key-1].item_description===val.item_description) ? "" : <>
                                <input
                                  required=''
                                  type='number'
                                  min='0'
                                  className='form-control'
                                  placeholder='Pkgs'
                                  onChange={(e) => onChangeEvent(key, e)}
                                  name='no_of_pkgs'
                                  value={val.no_of_pkgs}
                                />
                                {validator.current.message(
                                  'quantity',
                                  val.no_of_pkgs,
                                  'required',
                                  {
                                    className:
                                      'text-danger text-capitalize fSize10',
                                  }
                                )}
                              </>}
                              </div>

                              <div className='col-4 text-center'>
                                <div className='d-flex'>
                                  <div className='position-relative me-2'>
                                    <input
                                      required=''
                                      type='number'
                                      min='0'
                                      disabled={val.type==="select"}
                                      className='form-control '
                                      placeholder='Kilogram'
                                      onChange={(e) => onChangeEvent(key, e,'dimension')}
                                      name='kilogram'
                                      value={val.dimension.kilogram}
                                    />
                                    {validator.current.message(
                                      'Kilogram',
                                      val.dimension.kilogram,
                                      'required',
                                      {
                                        className:
                                          'text-danger text-capitalize customerror_msg',
                                      }
                                    )}
                                  </div>
                                  <div className='position-relative me-2'>
                                    <input
                                      required=''
                                      type='number'
                                      min='0'
                                      disabled={val.type==="select"}
                                      className='form-control'
                                      placeholder='Length'
                                      onChange={(e) => onChangeEvent(key, e,'dimension')}
                                      name='length'
                                      value={val.dimension.length}
                                    />
                                    {validator.current.message(
                                      'Length',
                                      val.dimension.length,
                                      'required',
                                      {
                                        className:
                                          'text-danger text-capitalize customerror_msg',
                                      }
                                    )}
                                  </div>

                                  <div className='position-relative me-2'>
                                    <input
                                      required=''
                                      type='number'
                                      min='0'
                                      disabled={val.type==="select"}
                                      className='form-control'
                                      placeholder='Width'
                                      onChange={(e) => onChangeEvent(key, e,'dimension')}
                                      name='width'
                                      value={val.dimension.width}
                                    />
                                    {validator.current.message(
                                      'Weight',
                                      val.dimension.width,
                                      'required',
                                      {
                                        className:
                                          'text-danger text-capitalize customerror_msg',
                                      }
                                    )}
                                  </div>

                                  <div className='position-relative'>
                                    <input
                                      required=''
                                      type='number'
                                      min='0'
                                      disabled={val.type==="select"}
                                      className='form-control'
                                      placeholder='Height'
                                      onChange={(e) => onChangeEvent(key, e,'dimension')}
                                      name='height'
                                      value={val.dimension.height}
                                    />
                                    {validator.current.message(
                                      'Height',
                                      val.dimension.height,
                                      'required',
                                      {
                                        className:
                                          'text-danger text-capitalize customerror_msg',
                                      }
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className='col-3'>
                                <div className='row'>
                                  <div className='col-5'>
                                {key>0 && val.type==="select" && (productItemForArray[key-1].item_description===val.item_description) ? "" :
                                    <input
                                      type='number'
                                      min='0'
                                      className='form-control'
                                      placeholder='CBM'
                                      name='total_volume_CBM'
                                      value={val.total_volume_CBM}
                                      disabled
                                    />}
                                  </div>
                                  <div className='col-5'>
                                  {key>0 && val.type==="select" && (productItemForArray[key-1].item_description===val.item_description) ? "" :
                                    <input
                                      required=''
                                      type='number'
                                      min='0'
                                      className='form-control'
                                      placeholder='KG'
                                      name='total_weight_KG'
                                      value={val.total_weight_KG}
                                      disabled
                                    />}
                                  </div>
                                  <div className='col-2'>
                                  {key>0 && val.type==="select" && (productItemForArray[key-1].item_description===val.item_description) ? "" :
                                    <button
                                      type='button'
                                      className='btn-close removePosition'
                                      onClick={() => deleteProductHandler(key,val)}
                                    ></button>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <div className='border-custom px-3 py-2 w-100'>
                        <div className='row'>
                          <div className='col-4'>
                            <p className='form-label text-center fw-bold w-100'>
                              Total
                            </p>
                          </div>

                          <div className='col-1'>
                            <p className='form-label text-center fw-bold'>
                            {getGrandTotal(productItemForArray)?.number_of_packages}
                              {/* {grandTotal.number_of_packages} */}
                            </p>
                          </div>

                          <div className='col-4'></div>

                            <div className='col-3 row'>
                          <div className='col-5'>
                            <p className='form-label text-center fw-bold'>
                            {getGrandTotal(productItemForArray)?.volume}
                              {/* {grandTotal.volume} */}
                            </p>
                          </div>

                          <div className='col-5'>
                            <p className='form-label text-center fw-bold w-100'>
                            {getGrandTotal(productItemForArray)?.weight}
                              {/* {grandTotal.weight} */}
                            </p>
                          </div>
                            </div>


                        </div>
                      </div>


                      <div className='row justify-content-between'>
                        <div className='col-3'>
                          <label className='form-label'>
                            Total Shipment Value
                          </label>
                          <input
                            required=''
                            type='number'
                            min='0'
                            className='form-control'
                            placeholder='Shipment Value'
                            name='items_goods'
                            onChange={(e) => setGoodValue(e.target.value)}
                          />
                          {validator.current.message(
                            'Shipment Value',
                            goodValue,
                            'required',
                            { className: 'text-danger text-capitalize' }
                          )}
                        </div>

                        <div className='col-6 text-end'>
                          <button
                            className='btn btn-success mt-3'
                            type='button'
                            onClick={() => addProductHandler()}
                          >
                            Add Product
                          </button>
                        </div>
                      </div>
                    </div>

               .
                    
                  </div>
                </div>
              </div>
            </section>









            <section className='sectionBorder mt-3'>
              <div className='card-header custom_header'>
                <h5>Customer Details</h5>
              </div>

              <div className='card-body'>
                <div className='row'>
                  <div className='mb-3 col-3'>
                    <label className='form-label'>Customer Email</label>
                    {/* <input
                      className='form-control'
                      type='email'
                      placeholder='Enter Customer Email'
                      name='customer_email'
                      value={email}
                      options={custmorOptions}
                      isLoading={isLoading}
                      onChange={(e) => {setEmail(e.target.value);
                      findCustomer(e.target.value)}}
                    /> */}


                    <AsyncTypeahead
                      filterBy={filterBy}
                      id="async-example"
                      isLoading={isLoading}
                      labelKey="user_email"
                      name="user_email"
                      minLength={2}
                      onSearch={findCustomer}
                      onChange={handleCustomerChange}
                      options={custmorOptions}
                      placeholder="Enter Customer Email"
                      renderMenuItemChildren={(option) => {
                        return (
                          <>
                            <span>{option.user_email}</span>
                          </>
                        )
                      }}
                    />

                    {validator.current.message(
                      'Customer Email',
                      email,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>
                  <div className='mb-3 col-3'>
                    <label className='form-label'>Customer Name</label>
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Enter Customer Name'
                      name='customer_name'
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                    {validator.current.message(
                      'Customer Name',
                      customerName,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>
                  <div className='mb-3 col-3'>
                    <label className='form-label'>Customer Number</label>
                    <PhoneInput
                      className='telinput'
                      country={'ae'}
                      enableSearch
                      value={Codenumber + Phonenumber}
                      enableAreaCodes={true}
                      onChange={(phone, f, g) => setQuotesPhone(phone, g)}
                    />
                    {validator.current.message(
                      'Customer Number',
                      Phonenumber,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>

                  <div className='mb-3 col-3'>
                    <label className='form-label'>Customer Type</label>
                    <Select
                      options={customer_Type}
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: 'calc(2.15rem + 2px)',
                          overflowY: 'visible',
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: '#d8dbe0',
                          boxShadow: '0 0 0 0px #d8dbe0',
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: '#d8dbe0',
                        }),
                      }}
                      value={usertype}
                      onChange={(e) => setUsertype(e)}
                    />
                    {validator.current.message(
                      'Customer Type',
                      usertype,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>

                  {/* <div className="mb-3 col-4">
                  <label className="form-label">Service</label>
                  <Select options={ServiceOption} />
                </div>

                <div className="mb-3 col-4">
                  <label className="form-label">Service Type</label>
                  <Select options={ServiceTypeoption} />
                </div> */}
                </div>
              </div>
            </section>

            <section className='sectionBorder mt-3'>
              <div className='card-header custom_header'>
                <h5>General Details</h5>
              </div>

              <div className='card-body'>
                <div className='row'>
                  <div className='mb-3 col-3'>
                    <label className='form-label'>Retailer Name</label>
                    <Select
                      options={retailerListData}
                      onChange={(e) => retailerHandler(e)}
                      // to get value on referral change 
                      value={retailerListData.find((item) => {
                        if (item.label === generalDetailsObj.retailer_name) {
                          return item;
                        }
                      })}
                    />

                    {/* {validator.current.message(
                      "Retailer Name",
                      generalDetailsObj.retailer_name,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )} */}
                  </div>

                  <div className='mb-3 col-3'>
                    <label className='form-label'>Referral Code</label>
                    <input
                      className='form-control'
                      type='text'
                      placeholder='Enter Referral Code'
                      onChange={(e) =>
                        handleRefferalChange(e)
                      }
                      value={generalDetailsObj.referral_code}
                    />
                    {generalDetailsObj.retailer_name &&
                      generalDetailsObj.retailer_name != 'None' &&
                      validator.current.message(
                        'Referral Code',
                        generalDetailsObj.referral_code,
                        'required',
                        { className: 'text-danger text-capitalize' }
                      )}
                  </div>

                  <div className='mb-3 col-3'>
                    <label className='form-label'>Sales Person Name</label>
                    {/* <Select
                      options={salesPersonList}
                      onChange={(e) =>
                        setGeneralDetailsObj({
                          ...generalDetailsObj,
                          sales_person: e?._id,
                        })
                      }
                      // to get value on referral change 
                      value={salesPersonList.find((item) => {
                        if (item?.label === generalDetailsObj?.sales_person) {
                          return item;
                        }
                      })}
                    /> */}
                    <input
                      className='form-control'
                      placeholder='Enter Sales Person Name '
                      value={generalDetailsObj.sales_person}
                      onChange={(e) =>
                        setGeneralDetailsObj({
                          ...generalDetailsObj,
                          sales_person: e.target.value,
                        })
                      }
                    />
                    {generalDetailsObj.retailer_name &&
                      generalDetailsObj.retailer_name != 'None' &&
                      validator.current.message(
                        'Sales Person Name',
                        generalDetailsObj?.sales_person,
                        'required',
                        { className: 'text-danger text-capitalize' }
                      )}
                  </div>

                  {/* <div className="mb-3 col-2">
                    <label className="form-label">Promo Code</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter Promo Code"
                      value={generalDetailsObj.promo_code}
                      onChange={(e) =>
                        setGeneralDetailsObj({
                          ...generalDetailsObj,
                          promo_code: e.target.value,
                        })
                      }
                    />
                    {generalDetailsObj.retailer_name &&
                      generalDetailsObj.retailer_name != "None" &&
                      validator.current.message(
                        "Promo Code",
                        generalDetailsObj.promo_code,
                        "required",
                        { className: "text-danger text-capitalize" }
                      )}
                  </div> */}

                  <div className='mb-3 col-3'>
                    <label className='form-label'>Customer Service</label>
                    <Select
                      options={customerServiceList}
                      onChange={(e) =>
                        setGeneralDetailsObj({
                          ...generalDetailsObj,
                          customer_service: e?.employee_name,
                        })
                      }
                      // to get value on referral change 
                        // if (item?.employee_name === generalDetailsObj?.customer_service) {
                        //   return item;
                        // }
                      value={customerServiceList.find((item) => {
                        return item?.employee_name === generalDetailsObj?.customer_service
                      })}
                      // value={customers.find((itm)=> itm.value===generalDetails.customer_service)}
                    />
                    {/* <input
                      className='form-control'
                      type='text'
                      placeholder='Enter Customer Service Name'
                      onChange={(e) =>
                        setGeneralDetailsObj({
                          ...generalDetailsObj,
                          customer_service: e.target.value,
                        })
                      }
                    /> */}
                    {validator.current.message(
                      'Customer Service',
                      generalDetailsObj.customer_service,
                      'required',
                      { className: 'text-danger text-capitalize' }
                    )}
                  </div>
                </div>
              </div>
            </section>

            <div className='card-body'>
              <div className='mt-3 d-flex justify-content-between'>
                <button
                  className='btn btn-danger w-sm waves-effect waves-light'
                  type='button'
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className='btn btn-primary w-sm waves-effect waves-light'
                  type='submit'
                >
                  Get Quote
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {(loader.air_loader == true ||
        loader.sea_loader == true ||
        loader.courier_loader == true ||
        loader.land_loader == true) && (
          <div className='loader_lt d-flex'>
            <svg
              style={{ margin: 'auto', background: '#fff', display: 'block' }}
              width='100px'
              height='100px'
              viewBox='0 0 100 100'
              preserveAspectRatio='xMidYMid'
            >
              <g transform='translate(20 20)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#e15b64'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.4s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(50 20)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#f47e60'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.3s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(80 20)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#f8b26a'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.2s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(20 50)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#f47e60'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.3s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(50 50)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#f8b26a'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.2s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(80 50)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#abbd81'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.1s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(20 80)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#f8b26a'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.2s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(50 80)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#abbd81'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='-0.1s'
                  ></animateTransform>
                </rect>
              </g>
              <g transform='translate(80 80)'>
                <rect x='-15' y='-15' width='30' height='30' fill='#849b87'>
                  <animateTransform
                    attributeName='transform'
                    type='scale'
                    repeatCount='indefinite'
                    calcMode='spline'
                    dur='1s'
                    values='1;1;0.2;1;1'
                    keyTimes='0;0.2;0.5;0.8;1'
                    keySplines='0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5'
                    begin='0s'
                  ></animateTransform>
                </rect>
              </g>
            </svg>
          </div>
        )}
       <Modal
       show={productModal.open}
       onHide={() => handleCloseModal()}
       animation={false}
       centered
     >
       <Modal.Body className='p-5'>
         <h5 className='form-label fw-bold my-2'>
            Select Product Information
          </h5>
          {productItem && (
            <div className="autocomplete-wrapper">

              <AutoCompleteProduct
                getItemValue={(item) => item.label}
                items={productItem}
                renderMenu={(item) => <div className="dropdown">{item}</div>}
                renderItem={(item, isHighlighted) => (
                  <div className={`item ${isHighlighted ? "selected-item" : ""}`}>
                    {item.label}
                  </div>
                )}
                inputProps={{ placeholder: 'Enter Product',autoFocus:true }}
                value={itemValue}
                onChange={(e) => searchHandler(e)}
                onSelect={(val) => handleChange(val)}
              />
            </div>
          )}
       </Modal.Body>
       <Modal.Footer className='d-flex justify-content-center mt-3'>
         <Button variant="success" className='px-5'  onClick={() =>  handleCloseModal()}>
          Back
         </Button>
         <Button variant="success" className='px-5'  onClick={() => addSelectedProduct()}>
          ADD
         </Button>
       </Modal.Footer>
     </Modal>
    </div>
  );
};
